import { addObjectToChildArray, removeObjectFromChildArray, updateObjectInChildArray } from "../utils/dbUtils";
import { isBooleanTrue, isNumberGreaterThanOrEqualToZero, isObjectNotEmpty, isStringNotEmpty } from "../utils/objectUtils";
import { v4 as uuid } from 'uuid';
import Encounter from "./Encounter";

class PrescriptionRequest {
    id = uuid();

    name = null; // medication/product name
    strength = null;
    quantity = 0;
    refills = 0;
    medRefId = null;
    productId = null;
    variantId = null;

    constructor(obj) {
        if (isObjectNotEmpty(obj)) {
            if (isStringNotEmpty(obj.id)) { this.id = obj.id; }

            if (isStringNotEmpty(obj.name)) { this.name = obj.name; }
            if (isStringNotEmpty(obj.strength)) { this.strength = obj.strength; }
            if (isNumberGreaterThanOrEqualToZero(obj.quantity)) { this.quantity = obj.quantity; }
            if (isNumberGreaterThanOrEqualToZero(obj.refills)) { this.refills = obj.refills; }
            if (isStringNotEmpty(obj.medRefId)) { this.medRefId = obj.medRefId; }
            if (isStringNotEmpty(obj.productId)) { this.productId = obj.productId; }
            if (isStringNotEmpty(obj.variantId)) { this.variantId = obj.variantId; }
        }
    }

    toDto = () => {
        return {
            id: this.id,

            name: this.name,
            strength: this.strength,
            quantity: this.quantity,
            refills: this.refills,
            medRefId: this.medRefId,
            productId: this.productId,
            variantId: this.variantId,
        }
    }

    static create = async (encounterId, prescriptionRequest) => {
        let newObj = new PrescriptionRequest(prescriptionRequest).toDto();

        const success = await addObjectToChildArray(Encounter.collectionName, encounterId, 'prescriptionRequests', 'id', newObj);
        if (isBooleanTrue(success)) {
            return newObj;
        }

        return null;
    }

    static update = async (encounterId, prescriptionRequest) => {
        let updatedObj = new PrescriptionRequest(prescriptionRequest).toDto();

        const success = await updateObjectInChildArray(Encounter.collectionName, encounterId, 'prescriptionRequests', 'id', updatedObj);
        if (isBooleanTrue(success)) {
            return updatedObj;
        }

        return null;
    }

    static remove = async (encounterId, prescriptionRequestId) => {
        return await removeObjectFromChildArray(Encounter.collectionName, encounterId, 'prescriptionRequests', 'id', prescriptionRequestId);
    }
};

export default PrescriptionRequest;